// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  /*.item, .item-divider {
    border-color: red;
  }*/
}
:host .beer-name {
  padding-left: 2px;
  font-size: 18px; /*1.3em;*/
  padding-bottom: 0px;
}
:host .brewery-name {
  padding-left: 2px;
  font-size: 14px; /*0.9em;*/
  padding-top: 0px;
}
:host .button-subtext {
  font-weight: lighter;
  text-transform: none;
  padding-left: 5px;
}
:host .button-inner {
  justify-content: flex-start;
}
:host img {
  max-width: 80px;
  max-height: 60px;
  width: auto;
  height: auto;
  display: block;
  margin: auto;
}
:host .imgholder {
  text-align: center;
  margin-left: 10px;
}
:host .label-md {
  line-height: 1;
}
:host td.beer-logo {
  text-align: right;
}
:host .list-ios > .item {
  /*order-top: 0.3px solid #c8c7cc;*/
  margin-left: 0px;
}
:host .list-md > .item {
  /*border-top: 0.3px solid #c8c7cc;*/
  margin-left: 0px;
}
:host .noitems {
  margin-left: 10px;
  margin-top: 0px;
  padding-top: 0px;
  font-size: 18px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
